import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="py-8 px-4 border-t border-gray-800" data-id="element-125">
      <div className="container mx-auto max-w-6xl" data-id="element-126">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-127">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.5
        }} viewport={{
          once: true
        }} data-id="element-128">
            <p className="text-gray-400 text-sm" data-id="element-129">
              © {new Date().getFullYear()} Sharon Tirado. Todos los derechos
              reservados.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} viewport={{
          once: true
        }} className="flex items-center gap-6" data-id="element-130">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-131">
              Política de Privacidad
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors" data-id="element-132">
              Términos y Condiciones
            </a>
          </motion.div>
        </div>
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-133">
          <p className="text-xs text-gray-500 flex items-center justify-center gap-1" data-id="element-134">
            Creado con <HeartIcon size={12} className="text-pink-500" data-id="element-135" /> para
            emprendedores digitales
          </p>
        </motion.div>
      </div>
    </footer>;
};